import { render, staticRenderFns } from "./ViewportPanel.vue?vue&type=template&id=3a2979b0&scoped=true"
import script from "./ViewportPanel.vue?vue&type=script&lang=js"
export * from "./ViewportPanel.vue?vue&type=script&lang=js"
import style0 from "./ViewportPanel.vue?vue&type=style&index=0&id=3a2979b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2979b0",
  null
  
)

export default component.exports